import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { toggleSwitch, popUpMenuChange } from '../../../actions/index'

import Icon from '@mdi/react';
import { mdiFindReplace } from '@mdi/js';

import { _ } from '../../../functions/translator'
import { ToggleActions } from '../../../constants/constants';

class ChangeLevelButton extends React.Component{
          
    handleClick = () => {
        this.props.toggleSwitch(ToggleActions.CHANGE_LEVEL_COMPONENT, true);
        this.props.popUpMenuChange({ show: false });
    }

    render(){   
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiFindReplace } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Editar Piso') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        toggleSwitch : toggleSwitch,
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ChangeLevelButton)